import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/Button";
import PublicLayout from "../layouts/PublicLayout";
import theme from "../utils/themeColors";

/**
 * Page not found component for non-authenticated users
 * Displays a 404 error message with navigation options
 */
const PageNotFoundPublic: React.FC = () => {
  const navigate = useNavigate();
  return (
    <PublicLayout>
      <div className="flex flex-col items-center justify-center text-center py-8 px-4">
        <div className="max-w-md mx-auto">
          <div className="text-7xl font-bold text-blue-600 dark:text-blue-400 mb-6">
            404
          </div>
          <h1 className={`text-3xl font-extrabold ${theme.text.primary} mb-4`}>
            Page not found
          </h1>
          <p className={`mb-8 ${theme.text.secondary}`}>
            Sorry, we couldn't find the page you're looking for. The page might
            have been removed, had its name changed, or is temporarily
            unavailable.
          </p>
          <div className="flex flex-col space-y-4 justify-center">
            <Button onClick={() => navigate("/signin")} variant="primary">
              Back To Login
            </Button>
            <Button onClick={() => navigate("/signup")} variant="outline">
              Create an Account
            </Button>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default PageNotFoundPublic;
